import React from 'react'

const House = props => (
  <svg viewBox="0 0 60 65" {...props}>
    <path d="M59.4 26.6L30.9 5.8c-.5-.4-1.3-.4-1.8 0L.6 26.6c-.7.5-.8 1.5-.3 2.2.5.7 1.5.8 2.2.3L30 9l27.5 20.1c.3.2.6.3.9.3.5 0 1-.2 1.3-.6.5-.7.4-1.7-.3-2.2zM51.8 30c-.9 0-1.6.7-1.6 1.6v24.8H37.8V42.8c0-4.3-3.5-7.8-7.8-7.8s-7.8 3.5-7.8 7.8v13.5H9.7V31.6c0-.9-.7-1.6-1.5-1.6s-1.6.7-1.6 1.6V58c0 .9.7 1.6 1.6 1.6h15.6c.8 0 1.5-.6 1.6-1.4V42.8c0-2.6 2.1-4.7 4.7-4.7s4.7 2.1 4.7 4.7V58c.1.8.7 1.4 1.6 1.4H52c.9 0 1.6-.7 1.6-1.6V31.6c-.2-.9-.9-1.6-1.8-1.6z" />
  </svg>
)

export default House
